import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import {browserHistory, withRouter} from 'react-router';
import Spinner from 'react-spinkit';
import _ from 'lodash';

import AssignmentFileSubmissionForm from "../components/AssignmentFileSubmissionForm";
import { DROPBOX__ASSIGNMENT__REQUESTED, DROPBOXES__REQUESTED, ROLES__SELF__REQUESTED } from "../constants/actionTypes";
import { INSTRUCTOR } from "../constants/roles";
import { underscoreToSpace} from "../helpers/helpers";


class AssignmentUploadPage extends AuthorizedComponent {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignment, dispatch, dropboxes, params, roles_self } = this.props,
            dropboxName = params.dropboxName,
            assignmentName = underscoreToSpace(params.assignmentName)
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.name === dropboxName) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (dropboxName && assignmentName && dropboxName.length > 0 && assignmentName.length > 0) {
                    dispatch ({
                        type: DROPBOX__ASSIGNMENT__REQUESTED,
                        payload: {
                            dropboxName : dropboxName,
                            assignmentName : assignmentName
                        }
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }

        if (prevProps.assignment !== assignment) {
            if (!assignment.use_assignment_files) {
                browserHistory.push('/not-found');
            }
        }
    }

    render() {
        const isLoading = this.props.request.sendingRequest;
        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignment, dropboxes, params } = this.props;

        return (
            <div className="table-responsive">
                {
                    _.map(
                        _.filter(
                            dropboxes,
                            dropbox => {
                                return dropbox.name === params.dropboxName;
                            }
                        ),
                        dropbox => {
                            return (
                                <AssignmentFileSubmissionForm
                                    key={"assignment_form"}
                                    className="submission-form"
                                    params={params}
                                    assignment={assignment}
                                    dropbox={dropbox}
                                />
                            );
                        }
                    )
                }
            </div>
        );
    }
}

AssignmentUploadPage.propTypes = {
    auth: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { assignment, auth, dropboxes, request, roles_self } = state;

    return { assignment, auth, dropboxes, request, roles_self };
}

export default connect(mapStateToProps)(withRouter(AssignmentUploadPage));



/** WEBPACK FOOTER **
 ** ./src/containers/AssignmentUploadPage.js
 **/